/**
 * @Author: brand
 * @Date: 2019-06-26 15:04
 * @Email: brandhuang@qq.com
 */
import ax from '../../axios'

/**
 * 获取总揽数据信息
 * @param params
 */
export function getReportDataAPI (params) {
    return ax({
        url: '/wlapi/index/indexTabTotal',
        method: 'POST',
        params
    })
}
// 折线图
export function getOverviewOnlineTendencyDataAPI (params) {
    return ax({
        url: '/wlapi/index/indexImgData',
        method: 'POST',
        params
    })
}
// 折线图
export function getOverviewCommentTendencyDataAPI (params) {
    return ax({
        url: '/wlapi/index/satisfiesImgData',
        method: 'POST',
        params
    })
}
// 首次响应时间
export function getOverviewFirstResponedDataAPI (params) {
    return ax({
        url: '/wlapi/index/firstRespond',
        method: 'POST',
        params
    })
}
// 会话时长
export function getOverviewCallTimeDataAPI (params) {
    return ax({
        url: '/wlapi/index/callTime',
        method: 'POST',
        params
    })
}
// 留言解决率
export function getOverviewLeaveSolveDataAPI (params) {
    return ax({
        url: '/wlapi/index/leaveSolve',
        method: 'POST',
        params
    })
}
// 满意度
export function getOverviewSatisfiesDataAPI (params) {
    return ax({
        url: '/wlapi/index/satisfies',
        method: 'POST',
        params
    })
}
// 商场数据
export function getShopDataAPI (params) {
    return ax({
        url: '/wlapi/statistics/marketing_statistics',
        method: 'POST',
        params
    })
}
// 商场数据--过去7天数据
export function getSevenDayDataAPI (params) {
    return ax({
        url: '/wlapi/statistics/get_week_marketing_statistics',
        method: 'POST',
        params
    })
}
// 商城列表
export function getmallListAPI (params) {
    return ax({
        url: '/wlapi/statistics/mall_list',
        method: 'POST',
        params
    })
}

// 商城退换货数据
export function getExchangeAPI (params) {
    return ax({
        url: '/wlapi/statistics/get_week_order_refund',
        method: 'POST',
        params
    })
}
